<div class="dropzone" (drop)="onDrop($event)" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)">
  <p>Drag and drop an image file here, or click to select one.</p>
  <input type="file" (change)="onFileInputChange($event)" accept="image/*" hidden />
</div>
<p *ngIf="loading">Processing image, please wait...</p>